import axios from 'axios';
import handleError from 'services/handleError';

const goToTheTask = async (toolPath, taskId, thunkAPI) => {
  try {
    const { data } = await axios.get(`${toolPath}/task/${taskId}/read`);

    return data;
  } catch (error) {
    if (!error.response) {
      return thunkAPI.rejectWithValue({
        message:
          'Network error. Please check your internet connection or try again later.',
        errorType: error.code || 'network_error',
        details: error.message,
      });
    }

    const status = error.response?.status;
    const data = error.response?.data;

    const errorDetails = await handleError(status, data);

    return thunkAPI.rejectWithValue(errorDetails);
  }
};

export default goToTheTask;
